export default __webpack_public_path__ + "static/media/results.57c80f91.png";